import { useEffect } from "react";
import Router from "next/router";
import Layout from "../../../components/Layout";
import { acaraPerusahaanMeta } from "../../../data/DataMetatags";
import NextHead from "../../../components/Seo/NextHead";
import { acaraPerusahaanBreadcrumb } from "../../../data/DataBreadcrumb";
import { fetchEvent } from "../../../utils/gateway";
import {
  breadcrumb,
  Content
} from "../../../components/tentang-perusahaan/general";

const acaraPerusahaan = ({
  error,
  pageTitle,
  descriptionSEO,
  asPath,
  eventCompany
}) => {
  useEffect(() => {
    if (error) {
      Router.push("/");
    }
  }, []);

  const bc = breadcrumb({ pageTitle, asPath });

  return (
    <Layout>
      <NextHead
        title={pageTitle}
        description={descriptionSEO}
        url={asPath}
        breadcrumb={bc}
      ></NextHead>
      <Content
        items={acaraPerusahaanBreadcrumb}
        heading="Acara Perusahaan"
        subSlug="acara-perusahaan"
        data={eventCompany}
      />
    </Layout>
  );
};

acaraPerusahaan.getInitialProps = async ({ asPath }) => {
  const pageTitle = acaraPerusahaanMeta.title;
  const descriptionSEO = acaraPerusahaanMeta.description;
  try {
    const eventCompany = await fetchEvent("");
    return { pageTitle, descriptionSEO, asPath, eventCompany };
  } catch (error) {
    return { error };
  }
};

export default acaraPerusahaan;
